import viewFromCompost2 from '../images/viewFromCompost2.jpg';
import wateringGarden from '../images/wateringGarden.jpg';
import fenceFlower1 from '../images/fenceFlower1.jpg';
import crocus from '../images/crocus.jpg';
import daffodil from '../images/daffodil.jpg';
import compost from '../images/compost.jpg';
import harvest from '../images/harvest.jpg';
import gardenView from '../images/newBackgroundResized.jpg';
import seedlings from '../images/seedlings.jpg';

// New images
import img122 from '../images/flowers1R.jpg';
import img133 from '../images/flowersBrickWall1R.jpg';
import gardenPlot1R from '../images/gardenPlot1R.jpg';
import img154 from '../images/leafCloseupR.jpg';
import img184 from '../images/newBackgroundResized.jpg';
import img197 from '../images/pondR.jpg';
import img216 from '../images/purpleFlowerR.jpg';
import img225 from '../images/yellowFlowerR.jpg';
import summerGreenhousePond from '../images/optimized/summer-greenhouse-pond-web.jpg';
import summerGreenhousePondThumb from '../images/optimized/summer-greenhouse-pond-thumb.jpg';
import squashBrassicasPlot from '../images/optimized/squash-vines-brassicas-summer-plot-web.jpg';
import squashBrassicasPlotThumb from '../images/optimized/squash-vines-brassicas-summer-plot-thumb.jpg';
import sunflowersGardenSeating from '../images/optimized/sunflowers-garden-seating-web.jpg';
import sunflowersGardenSeatingThumb from '../images/optimized/sunflowers-garden-seating-thumb.jpg';
import trellisedTomatoesBrickPath from '../images/optimized/trellised-tomatoes-brick-path-web.jpg';
import trellisedTomatoesBrickPathThumb from '../images/optimized/trellised-tomatoes-brick-path-thumb.jpg';
import butterflyBushGardenSeating from '../images/optimized/butterfly-bush-shared-garden-seating-web.jpg';
import butterflyBushGardenSeatingThumb from '../images/optimized/butterfly-bush-shared-garden-seating-thumb.jpg';
import gardenPathHistoricSchool from '../images/optimized/garden-path-historic-school-web.jpg';
import gardenPathHistoricSchoolThumb from '../images/optimized/garden-path-historic-school-thumb.jpg';

export const homepageImages = [
  {
    id: 1,
    url: fenceFlower1,
    description: 'artistic view of our plots through the fence'
  },
  {
    id: 2,
    url: gardenPlot1R,
    description: 'a view of one of our beautiful garden plots'
  },
  {
    id: 3,
    url: wateringGarden,
    description: 'A member watering her garden'
  }
];

export const galleryImages = [
  {
    id: 23,
    url: squashBrassicasPlot,
    thumbnailUrl: squashBrassicasPlotThumb,
    title: 'Squash vines and brassicas in a summer plot',
    description: 'Sprawling squash vines, cabbage and collard leaves, herbs, and tall tomato plants crowd a productive summer garden plot.',
    tags: ['squash', 'squash vines', 'cabbage', 'collards', 'collard greens', 'brassicas', 'tomatoes', 'tomato plants', 'herbs', 'vegetable plot', 'summer', 'productive garden']
  },
  {
    id: 24,
    url: sunflowersGardenSeating,
    thumbnailUrl: sunflowersGardenSeatingThumb,
    title: 'Sunflowers and garden seating',
    description: 'Sunflowers and colorful summer flowers surround a pair of chairs, garden ornaments, trellises, and a narrow path through the plots.',
    tags: ['sunflowers', 'summer flowers', 'garden seating', 'chairs', 'garden ornaments', 'trellises', 'garden path', 'flower garden', 'community space', 'summer']
  },
  {
    id: 25,
    url: trellisedTomatoesBrickPath,
    thumbnailUrl: trellisedTomatoesBrickPathThumb,
    title: 'Trellised tomatoes along the brick path',
    description: 'Rows of tomato vines climb black metal trellises beside a narrow brick path, with a vigorous squash or gourd vine overhead.',
    tags: ['tomatoes', 'tomato vines', 'tomato trellis', 'metal trellis', 'squash vine', 'gourd vine', 'brick path', 'vegetable garden', 'raised beds', 'summer']
  },
  {
    id: 26,
    url: butterflyBushGardenSeating,
    thumbnailUrl: butterflyBushGardenSeatingThumb,
    title: 'Butterfly bush and shared garden seating',
    description: 'Purple butterfly bush blooms beside curved perennial and herb beds, with bright blue chairs and a shared table under mature trees.',
    tags: ['butterfly bush', 'buddleia', 'purple flowers', 'perennials', 'herbs', 'garden beds', 'blue chairs', 'garden seating', 'shared table', 'mature trees', 'community space', 'pollinator garden']
  },
  {
    id: 27,
    url: gardenPathHistoricSchool,
    thumbnailUrl: gardenPathHistoricSchoolThumb,
    title: 'Garden path toward the historic school',
    description: 'A winding path passes brick-edged beds of tomatoes, basil, flowers, and other summer crops with the historic neighborhood school beyond.',
    tags: ['garden path', 'historic school', 'school building', 'brick-edged beds', 'tomatoes', 'basil', 'herbs', 'flowers', 'summer crops', 'neighborhood', 'urban garden', 'wide view']
  },
  {
    id: 18,
    url: summerGreenhousePond,
    thumbnailUrl: summerGreenhousePondThumb,
    title: 'Corn, greenhouse, and summer pond',
    description: 'Tall sweet corn and tomato plants grow beside the greenhouse and a duckweed-covered pond, with carrots and red-stemmed chard in the foreground. Solar panels on the historic garden wall power the weather station and garden lights.',
    tags: ['sweet corn', 'corn', 'corn tassels', 'tomatoes', 'tomato plants', 'carrots', 'carrot tops', 'swiss chard', 'red chard', 'leafy greens', 'greenhouse', 'pond', 'duckweed', 'aquatic plants', 'arrowhead plants', 'reclaimed bricks', 'brick wall', 'historic wall', 'solar panels', 'solar power', 'weather station', 'garden lights', 'summer', 'urban garden']
  },
  {
    id: 1,
    url: viewFromCompost2,
    title: 'Spring view from the compost area',
    description: 'A wheelbarrow filled with finished compost overlooks raised beds, herbs, paths, and garden plots in early spring.',
    tags: ['compost', 'wheelbarrow', 'soil', 'raised beds', 'herbs', 'garden plots', 'spring', 'wide view']
  },
  {
    id: 2,
    url: crocus,
    title: 'Striped spring crocuses',
    description: 'Purple-and-white striped crocuses with orange centers bloom through fallen leaves in early spring.',
    tags: ['crocus', 'crocuses', 'flowers', 'purple flowers', 'striped flowers', 'spring bulbs', 'early spring']
  },
  {
    id: 3,
    url: daffodil,
    title: 'Yellow daffodils',
    description: 'A cluster of bright yellow daffodils blooms in an early spring garden bed.',
    tags: ['daffodil', 'daffodils', 'narcissus', 'flowers', 'yellow flowers', 'spring bulbs', 'early spring']
  },
  {
    id: 4,
    url: compost,
    title: 'Finished garden compost',
    description: 'A handful of dark, crumbly finished compost shows the organic material used to enrich the garden soil.',
    tags: ['compost', 'finished compost', 'soil', 'organic matter', 'soil amendment', 'garden work', 'hand']
  },
  {
    id: 5,
    url: seedlings,
    title: 'Lettuce, arugula, and parsley seedlings',
    description: 'Romaine lettuce, arugula, and parsley seedlings emerge in a labeled seed-starting tray under a clear cover.',
    tags: ['seedlings', 'seed starting', 'romaine lettuce', 'lettuce', 'arugula', 'parsley', 'herbs', 'leafy greens', 'spring']
  },
  {
    id: 6,
    url: harvest,
    title: 'Tomato, pepper, and bean harvest',
    description: 'Freshly picked green tomatoes, green peppers, flat beans, and cut flowers sit beside garden shears near the pond.',
    tags: ['harvest', 'tomatoes', 'green tomatoes', 'peppers', 'green peppers', 'beans', 'flat beans', 'vegetables', 'produce', 'cut flowers', 'garden shears', 'pond']
  },
  {
    id: 7,
    url: gardenView,
    title: 'Sunny brick-edged garden beds',
    description: 'Morning sun falls across brick-edged flower and herb beds, red blooms, paths, mature trees, and the garden shed.',
    tags: ['garden', 'brick beds', 'raised beds', 'flowers', 'red flowers', 'herbs', 'garden shed', 'trees', 'sunlight', 'wide view']
  },
  {
    id: 8,
    url: img122,
    title: 'Sweet William flowers',
    description: 'Pink, white, and magenta Sweet William flower clusters bloom among dense green leaves.',
    tags: ['sweet william', 'dianthus', 'dianthus barbatus', 'flowers', 'pink flowers', 'white flowers', 'magenta flowers', 'flower clusters', 'summer']
  },
  {
    id: 9,
    url: img133,
    title: 'White anemones by the brick wall',
    description: 'White anemones bloom in front of blue-green hosta leaves, tall iris foliage, and the historic brick wall.',
    tags: ['anemone', 'anemones', 'white flowers', 'hosta', 'iris leaves', 'foliage', 'brick wall', 'historic wall', 'shade garden']
  },
  {
    id: 10,
    url: wateringGarden,
    title: 'Watering vegetables and leafy greens',
    description: 'A garden member waters a thriving plot planted with tomatoes, red-stemmed chard, herbs, and other leafy greens.',
    tags: ['watering', 'gardener', 'garden member', 'people', 'tomatoes', 'swiss chard', 'chard', 'leafy greens', 'herbs', 'vegetable plot', 'garden work']
  },
  {
    id: 11,
    url: fenceFlower1,
    title: 'Chocolate vine on the garden fence',
    description: 'Purple chocolate vine flowers and palmate leaves frame a sunset view through the chain-link fence into the garden.',
    tags: ['chocolate vine', 'akebia', 'akebia quinata', 'vine', 'purple flowers', 'fence', 'chain-link fence', 'sunset', 'garden view']
  },
  {
    id: 12,
    url: img154,
    title: 'Cabbage, collards, and bok choy',
    description: 'Large blue-green cabbage or collard leaves fill the foreground, with rows of bok choy and other leafy vegetables behind them.',
    tags: ['cabbage', 'collards', 'collard greens', 'bok choy', 'pak choi', 'leafy greens', 'brassicas', 'vegetables', 'close-up']
  },
  {
    id: 13,
    url: img184,
    title: 'Sunny brick-edged garden beds',
    description: 'Morning sun falls across brick-edged flower and herb beds, red blooms, paths, mature trees, and the garden shed.',
    tags: ['garden', 'brick beds', 'raised beds', 'flowers', 'red flowers', 'herbs', 'garden shed', 'trees', 'sunlight', 'wide view']
  },
  {
    id: 14,
    url: img197,
    title: 'Brick pond and aquatic plants',
    description: 'A small brick-lined pond holds pickerelweed and iris-like aquatic plants beneath a carved Green Man on the historic wall.',
    tags: ['pond', 'water garden', 'aquatic plants', 'pickerelweed', 'water iris', 'brick pond', 'brick wall', 'green man', 'garden ornament']
  },
  {
    id: 15,
    url: img216,
    title: 'Dwarf crested iris',
    description: 'A blue-violet dwarf crested iris opens above narrow green leaves.',
    tags: ['dwarf crested iris', 'crested iris', 'iris cristata', 'iris', 'blue flower', 'purple flower', 'violet flower', 'spring flower']
  },
  {
    id: 16,
    url: gardenPlot1R,
    title: 'Peonies and raised garden beds',
    description: 'Red peonies and mixed plantings grow around raised beds, with a blue gazing globe in the foreground.',
    tags: ['peonies', 'red peonies', 'flowers', 'raised beds', 'garden plot', 'mixed planting', 'gazing globe', 'garden ornament']
  },
  {
    id: 17,
    url: img225,
    title: 'Orange marigold',
    description: 'A ruffled orange marigold blooms above fernlike green foliage.',
    tags: ['marigold', 'african marigold', 'tagetes', 'orange flower', 'yellow flower', 'companion plant', 'summer flower']
  }
];
